var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.584 18.125c-4.709 0-8.542-3.833-8.542-8.542 0-4.708 3.833-8.541 8.542-8.541 4.708 0 8.541 3.833 8.541 8.541 0 4.709-3.833 8.542-8.541 8.542Zm0-15.833c-4.025 0-7.292 3.275-7.292 7.291 0 4.017 3.267 7.292 7.292 7.292s7.291-3.275 7.291-7.292c0-4.016-3.266-7.291-7.291-7.291ZM18.334 18.958a.618.618 0 0 1-.442-.183l-1.667-1.667a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l1.667 1.667a.629.629 0 0 1 0 .883.618.618 0 0 1-.441.183Z",
    fill: "#E0E0E0"
  })));
};
export default SvgSearch;